const allowVerbs = [
  "http://adlnet.gov/expapi/verbs/answered",
  "http://adlnet.gov/expapi/verbs/completed",
  // "http://adlnet.gov/expapi/verbs/progressed",
  // "http://adlnet.gov/expapi/verbs/interacted",
];

const allowDomains = [
  "https://ua-h5p.pistacja.tv",
  "https://h5p.pi-stacja.pl",
  "https://h5p.pistacja.tv",
];

export default function H5PTracker(endpointURL, options = "") {

  if (typeof endpointURL !== "string") {
    throw new Error("endpointURL must be a string");
  }

  window.addEventListener("message", (event) => {

    if (options.includes("--debug-all")) {
      console.log(event.data);
    }

    if (allowMessges(event)) {

      if (options.includes("--debug") && !options.includes("-all")) {
        console.log(event.data);
      }

      if (isAllowedVerb(event.data)) {
        const parsedData = getTrackerProps(event.data);

        if (!options.includes("--mute")) {
          console.log("Sending data to endpoint: ", parsedData);
        }

        fetch(endpointURL, {
          method: "POST",
          credentials: "include",
          body: JSON.stringify(parsedData),
          headers: {
            "content-type": "application/json",
          }
        }).then((response) => {
          if (!options.includes("--mute")) {
            response.status === 200
              ? console.log("Data posted")
              : console.error(`Cannot POST data: (${response.status}) ${response.statusText}`);
          }
        });
      }
    }
  });
}

// ---- Helpers ----------------

function allowMessges(messge) {
  return allowDomains.includes(messge.origin) && messge.data.action === "pie-h5p-xapi";
}

function isAllowedVerb(response) {
  const id = response?.statement?.verb.id;
  return id && allowVerbs.includes(id);
}

function getTrackerProps(data) {
  return {
    contentsId: data.statement.object.definition.extensions["http://h5p.org/x-api/h5p-local-content-id"],
    subcontentsId: data.statement.object.definition.extensions["http://h5p.org/x-api/h5p-subContentId"],
    verb: data.statement.verb.id,
    result: {
      response: data.statement.result.response || null,
      duration: data.statement.result.duration,
      completion: data.statement.result.completion,
      success: data.statement.result.success === undefined ? null : data.statement.result.success,
      scoreScaled: data.statement.result.score.scaled,
    },
    timestamp: Date.now(),
    actorName: data.statement.actor.account ? data.statement.actor.account.name : data.statement.actor.name,
  };
}
